import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiControllerActionEnum } from '../models/enums/ApiControllerActionEnum';
import { EvaluationLogsMasterModel } from '../models/Evaluation/EvaluationLogsMasterModel';
import { EvaluationParmModel } from '../models/Evaluation/EvaluationParmModel';
import { EvaluationSummaryModel } from '../models/Evaluation/EvaluationSummaryModel';
import { LanguageModel } from '../models/LanguageModel';
import { ResourceService } from './resource.service';

@Injectable({
  providedIn: 'root'
})
export class EvaluationService {
selectedLanguageIsoCode: string;
selectedLanguage: LanguageModel;

private _customerEvaluation = new BehaviorSubject<EvaluationSummaryModel>(null);
readonly customerEvaluation = this._customerEvaluation.asObservable();
private dataStore: { customerEvaluation:EvaluationSummaryModel} = { customerEvaluation:null};

constructor(private http: HttpClient, private resouceService: ResourceService) {

  this.selectedLanguageIsoCode = "en";
  resouceService.selectedLanguage.subscribe(res => {

    this.selectedLanguage = res;
    if (res != null) {
      this.selectedLanguageIsoCode = res.isoCode2;
    }
  })
}
updateCustomerEvaluation(model: EvaluationSummaryModel) {
  this.dataStore.customerEvaluation = model;
  this._customerEvaluation.next(Object.assign({}, this.dataStore).customerEvaluation);
}

getEvaluationSummary(model:EvaluationParmModel) {
  model.Language=this.selectedLanguageIsoCode;
  return this.http.post<EvaluationSummaryModel>(ApiControllerActionEnum.EvaluationSummary,JSON.stringify(model) );
}
getEvaluationLogsMasters(model) {
  return this.http
    .post<Array<EvaluationLogsMasterModel>>(
      ApiControllerActionEnum.EvaluationLogsMasters ,JSON.stringify(model)
    );
}

}
